import { ColGroupDef } from '@ag-grid-community/core';
import {
  AgGridHelperService,
  ProductColGroupId,
} from '@products/fund-listing/services/ag-grid-helper.service';
import { FundListingRatingsController } from '../controllers';

/**
 * Return default rating column definitions for CZ.
 * @param listingController ppss tab component
 * @param agGridHelperService ag grid helper service instance
 */
export function getDefaultRatingColumnDefsForCZ(
  listingController: FundListingRatingsController,
  agGridHelperService: AgGridHelperService
): ColGroupDef[] {
  return [
    {
      groupId: ProductColGroupId.FUND,
      children: [agGridHelperService.getFundNameColDef()],
    },
    {
      groupId: ProductColGroupId.CURRENCY,
      children: [agGridHelperService.getCurrencyColDef()],
    },
    {
      groupId: ProductColGroupId.MORNINGSTAR,
      headerGroupComponent: 'ratingsGroupHeaderComponent',
      headerGroupComponentParams: listingController,
      headerClass: 'ag-header-group-cell--noflex',
      children: [
        agGridHelperService.getMorningStarCategoryColDef(listingController),
        agGridHelperService.getMorningStarOverallRatingColDef(
          listingController,
          {
            minWidth: 360,
          }
        ),
      ],
    },
  ];
}
